import React, { JSX } from 'react'
import { YouTubeRoles } from 'lib/twitchChatParse'

export type YouTubeRole = keyof YouTubeRoles

export const YOUTUBE_ROLE_ORDER: readonly YouTubeRole[] = ['owner', 'moderator', 'member', 'verified']

const ROLE_LABELS: Record<YouTubeRole, string> = {
  owner: 'Channel owner',
  moderator: 'Moderator',
  member: 'Member',
  verified: 'Verified'
}

const OwnerShape = (): JSX.Element => (
  <path fill='#FFD600' d='M3 17.5h18V20H3z M3 6.5l5 4.5L12 4l4 7 5-4.5-1.6 9.4H4.6z' />
)

const ModeratorShape = (): JSX.Element => (
  <>
    <path fill='#5E84F1' d='M20.95 5.6L17.98 8.57L15.43 6.02L18.4 3.05A5.5 5.5 0 1 0 20.95 5.6Z' />
    <path stroke='#5E84F1' strokeWidth='3.6' strokeLinecap='round' fill='none' d='M13.2 10.8L5 19' />
  </>
)

const MemberShape = (): JSX.Element => (
  <path fill='#2BA640' d='M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3l-5.9 3.3 1.3-6.6-4.9-4.6 6.6-.8z' />
)

const VerifiedShape = (): JSX.Element => (
  <path
    fill='#AAAAAA'
    fillRule='evenodd'
    d='M12 2a10 10 0 1 0 0 20a10 10 0 1 0 0-20z M6.6 12.4L8 11l2.5 2.5L16 8l1.4 1.4l-6.9 6.9z'
  />
)

const SHAPES: Record<YouTubeRole, () => JSX.Element> = {
  owner: OwnerShape,
  moderator: ModeratorShape,
  member: MemberShape,
  verified: VerifiedShape
}

export const YouTubeRoleGlyph = ({
  role,
  style
}: {
  role: YouTubeRole
  style: React.CSSProperties
}): JSX.Element => {
  const Shape = SHAPES[role]
  const label = ROLE_LABELS[role]
  return (
    <svg
      viewBox='0 0 24 24'
      role='img'
      aria-label={label}
      data-youtube-role={role}
      style={style}
    >
      <title>{label}</title>
      <Shape />
    </svg>
  )
}

export const YouTubeRoleBadges = ({
  roles,
  style
}: {
  roles: YouTubeRoles | undefined
  style: React.CSSProperties
}): JSX.Element | null => {
  if (roles === undefined) return null
  const held = YOUTUBE_ROLE_ORDER.filter((role) => roles[role])
  if (held.length === 0) return null
  return (
    <>
      {held.map((role) => (
        <YouTubeRoleGlyph key={role} role={role} style={style} />
      ))}
    </>
  )
}
